import React, { useCallback } from 'react'
import { DeleteOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import PropTypes from 'prop-types'

import { useDeletePriorityTaskMutation } from '../../hooks'

const PriorityTaskDeleteButton = ({ taskId }) => {
  const [deletePriorityTask] = useDeletePriorityTaskMutation()

  const handleDelete = useCallback(() => {
    deletePriorityTask(taskId)
  }, [deletePriorityTask, taskId])

  return (
    <Popconfirm
      title="This action is irreversible. Are you sure you want to delete this priority task?"
      onConfirm={handleDelete}
    >
      <Button icon={<DeleteOutlined />} />
    </Popconfirm>
  )
}

PriorityTaskDeleteButton.propTypes = {
  taskId: PropTypes.string.isRequired,
}

export default PriorityTaskDeleteButton
